/*
 * Copyright (c) 2026-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

import { create } from 'zustand';

/**
 * A sentence confirming what just happened.
 *
 * Announced politely to a screen reader rather than interrupting: it confirms,
 * it never asks. Anything a person must act on is a dialog or an inline error,
 * not this.
 */
interface ToastState {
  message: string;
  /** Changes on every call, so the same message twice still re-announces. */
  seq: number;
  say: (message: string) => void;
  clear: () => void;
}

export const useToast = create<ToastState>((set, get) => ({
  message: '',
  seq: 0,
  say: (message) => {
    set({ message, seq: get().seq + 1 });
  },
  clear: () => {
    set({ message: '' });
  },
}));

export function toast(message: string): void {
  useToast.getState().say(message);
}
